import { render, staticRenderFns } from "./LikeIcon2.vue?vue&type=template&id=05432dde&scoped=true&"
import script from "./LikeIcon2.vue?vue&type=script&lang=js&"
export * from "./LikeIcon2.vue?vue&type=script&lang=js&"
import style0 from "./LikeIcon2.vue?vue&type=style&index=0&id=05432dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05432dde",
  null
  
)

export default component.exports